import clsx from "clsx";
import useSystemHealthStatus from "./hooks/useSystemHealthStatus";
import RlNavigationDropdownItem from "../navigation/components/RlNavigationDropdownItem";
import SystemHealthIcon from "./components/SystemHealthIcon";
import SystemHealthDropdownItem from "./components/SystemHealthDropdownItem";
import { route } from "../../../shim/jsbridge";
import { prepareHealthData } from "./utils";

const { isSuperuser } = window.tcbase || {};

const SystemHealth = () => {
  const { isHealthy, healthIssues, systemHealthStatus } =
    useSystemHealthStatus();

  const { healthData } = prepareHealthData({
    isHealthy,
    healthIssues,
    systemHealthStatus
  });

  return (
    <RlNavigationDropdownItem
      title={<SystemHealthIcon notHealthy={!isHealthy} />}
      className={clsx("system-health", !isHealthy && "not-healthy")}
      id="system-health"
    >
      <>
        {healthData.map(({ id, icon, title, content, isMetricHealthy }) => (
          <SystemHealthDropdownItem
            id={id}
            key={icon || title}
            icon={icon}
            title={title}
            content={content}
            isMetricHealthy={isMetricHealthy}
          />
        ))}

        <div className="system-health__dropdown-item">
          {isSuperuser && (
            <a
              href={route("system_status")}
              className="main-nav__submenu-item-link"
            >
              Open System Status Page
            </a>
          )}
          {!isHealthy && !isSuperuser && (
            <>Please contact the system administrator</>
          )}
        </div>
      </>
    </RlNavigationDropdownItem>
  );
};
export default SystemHealth;
